import { AddWidgetDrawer } from 'dashboards/components/WidgetDrawer/AddWidgetDrawer';
import { ConfirmDeleteDialog } from 'components/ConfirmDialog/ConfirmDeleteDialog';
import { ConfirmDialog } from 'components/ConfirmDialog/ConfirmDialog';
import { CopilotChatDrawer } from 'components/CopilotChat/CopilotChatDrawer';
import { CopyWidgetToDashboardDialog } from 'dashboards/components/CopyWidgetToDashboardDialog/CopyWidgetToDashboardDialog';
import { CreateDashboardDialog } from 'dashboards/components/CreateDashboardDialog/CreateDashboardDialog';
import { EditWidgetDrawer } from 'dashboards/components/WidgetDrawer/EditWidgetDrawer';
import { FileLightbox } from 'files/components/Lightbox/Lightbox';
import { FilesSearchDrawer } from 'files/components/FilesSearchDrawer/FilesSearchDrawer';
import { LogInspector } from 'components/Logs/components/LogInspector';
import { RenameDashboardDialog } from 'dashboards/components/RenameDashboardDialog/RenameDashboardDialog';
import { StreamLightbox } from 'streams/components/Lightbox/Lightbox';

export const MODAL_REGISTRY = {
  'add-widget': AddWidgetDrawer,
  'confirm-delete': ConfirmDeleteDialog,
  'copilot-chat': CopilotChatDrawer,
  'copy-widget-to-dashboard': CopyWidgetToDashboardDialog,
  'create-dashboard': CreateDashboardDialog,
  'deployment-log': LogInspector,
  'edit-widget': EditWidgetDrawer,
  'files-search': FilesSearchDrawer,
  'rename-dashboard': RenameDashboardDialog,
  confirm: ConfirmDialog,
  file: FileLightbox,
  stream: StreamLightbox,
} as const;
